import type { ContactUsConfig } from './types'
import { commonTexts } from './common'
import { theme as brandTheme } from '@/config/brands'

/**
 * Storlyn 品牌 Contact Us 页面配置
 */
export const contactUsConfig: ContactUsConfig = {
  texts: commonTexts,
  colors: {
    bgPrimary: brandTheme.bgGlobal,
    bgTertiary: brandTheme.bgTag,
    textPrimary: brandTheme.textPrimary,
    textTertiary: brandTheme.textTertiary,
    textPlaceholder: brandTheme.textTertiary,
    accentRed: brandTheme.primaryColor,
    primaryColor: brandTheme.primaryColor,
    whiteColor: brandTheme.textInverse,
  },
}
